<template>
<div class="headView">
<div class="certificatelnView">
          <div class="homeTitleCenter">
            <img
              src="../../assets/logo.png"
              @click="goHomeUrl()"
              alt=""
              class="logo"
            />
          </div>
        <div class="searchView">
        
          <el-input placeholder="请输入证书编号后5位" v-model="searchValue" ></el-input>
          <el-button type="primary" @click="search">查询</el-button>
        </div>
                <div class="certificateInquiryView" v-if="setup==1">
        <img :src="certificateInquiryImg" class="certificateInquiryImg">
        </div>
        <!-- //空 -->
        <div v-if="setup==2">
        <div class="emptyView">
        <img src="../../assets/empty.png" class="emptyImg" alt="">
        </div>
        <div class="emptyText">证书已失效，如有其他问题请联系双推双促办公室</div>

        </div>

</div>
</div>

</template>

<script>

export default {
  name: "CertificateInquiry",
  data() {
      return {
        setup:0,
        searchValue:'',
        certificateInquiryImg:''
      }
  },
  mounted() {
    console.log("this.$route",this.$route)
    this.searchValue = this.$route.query.cer_num
    if(this.searchValue){
        this.search()
    }
  },
  methods: {
    search(){
        if(!this.searchValue){
            this.setup = 0
            return this.$message.error('请输入证书编号')
        }
        this.$API.cerQuery({
            cer_num:this.searchValue
        }).then(res=>{
            console.log(res)
                this.certificateInquiryImg = res.data.cer_url
                this.setup = this.certificateInquiryImg?1:2
        })
    },
    goHomeUrl() {
      window.open("https://www.isefc.org/index.php/zh/", "_blank");
    },
  }

};
</script>

<style scoped lang='less'>
.certificateInquiryView{
    padding: 0 100px;
    padding-top: 20px;
}
.certificateInquiryImg{
    width: 100%;
    height: 650px;
   display: block;
    margin: 0 auto;
    object-fit: contain;
}
.emptyText{
    text-align: center;
    font-size: 22px;
    color: #666;
    margin-top: 30px;
}
.emptyView{
    display: flex;
    justify-content: center;
    padding-top: 50px;
}
.emptyImg{
    max-width: 100%;
    height: auto;
}

.searchView{
    display: flex;
    padding: 0 100px;
    margin-top: 20px;
}
::v-deep .el-input-group__append {
  background: #0366F1;
  color: #fff;
}
::v-deep .el-input-group__append .search-btn {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
}
.homeTitleCenter{
    display: flex;
    justify-content: center;
    padding-top: 10px;
}
.logo {
  height: 72px;
  width: 405px;
  object-fit: contain;

  margin-top: 10px;
}
.headView{
     min-height: 100vh;
     background: #fff;
}
.certificatelnView{
    width: 1200px;
     margin: 0 auto;

}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .certificatelnView {
    width: 100%;
    padding: 0 15px;
  }

  .homeTitleCenter {
    padding-top: 5px;
  }

  .logo {
    width: 240px;
    height: auto;
  }

  .searchView {
    flex-direction: column;
    padding: 0;
    margin-top: 15px;
    gap: 10px;

    .el-input {
      width: 100%;
    }

    .el-button {
      width: 100%;
    }
  }

  .certificateInquiryView {
    padding: 15px 0;
  }

  .certificateInquiryImg {
    width: 100%;
    height: auto;
    min-height: 200px;
  }

  .emptyView {
    padding-top: 30px;
  }

  .emptyImg {
    width: 200px;
  }

  .emptyText {
    font-size: 16px;
    padding: 0 20px;
  }
}

</style>